import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from '../Utils/api';

export const useSinglePost = (token, postId) => {
  return useQuery({
    queryKey: ['post', postId],
    queryFn: async () => {
      if (!token || !postId) return null;
      const res = await axios.get(`${API_URL}/post/${postId}`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data;
    },
    enabled: !!token && !!postId,
    staleTime: 1000 * 60, 
  });
};
